import { BaseRequest } from '@/network/requests/BaseRequest'
import { jt_info } from '@/interfaces/jt_info'
import { FilterQuery } from '@/network/interfaces/FilterQuery'
import { jtStatusRequest } from './jtStatus'

/**
 * 机台信息请求。
 */
export const jtInfoRequest = BaseRequest.build<jt_info>('jt_info')

/**
 * 返回机台id映射到机台名称的 Map
 */
export async function getJTIdNameMap(...jtIds: string[]) {
	const map = new Map<string, string>()
	if (jtIds.length === 0) {
		return map
	}
	const jtList = await jtInfoRequest.queryByIds(jtIds, { name: 1 })
	return jtList.reduce((acc, curr) => {
		acc.set(curr._id?.$oid || '', curr?.name || '')
		return acc
	}, map)
}

export async function getJTIdName(name1) {
	const jtList = await jtInfoRequest.queryAll({ name: name1 })
	return jtList[0]
}

/**
 * 根据车间查询机台列表。
 * @param workshopId 车间Id。
 */
export async function queryJTListOfWorkshop(workshopId: string) {
	return jtInfoRequest.queryAll({
		workshop_id: workshopId,
	})
}

/**
 * 获取车间所有机台设备。
 * @param workshopId 车间Id
 */
var getDevices = (filters?: FilterQuery) => {
	return jtInfoRequest.queryAll(filters)
}

/**
 * 保存机台信息。
 * @param obj 机台信息对象。
 */
var save = (obj: jt_info) => {
	if (obj._id?.$oid) {
		return jtInfoRequest.modifyById(obj._id.$oid, obj)
	} else {
		return jtInfoRequest.upload(obj)
	}
}

/**
 * 设置工艺参数组。
 * @param deviceId
 * @param techGroupId
 * @param techGroupName
 */
var setTeachGroup = (deviceId: string, techGroupId: string, techGroupName: string) => {
	return jtInfoRequest.modifyById(deviceId, {
		tech_group_id: techGroupId,
		tech_group_name: techGroupName,
	})
}

export default {
	getDevices,
	save,
	setTeachGroup,
}
